import React, { useContext } from 'react';
import {
  Segment, List, Header, Message,
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import DataContext from '../../../../../contexts/DataContext';

const ExternalAccountStatuses = ({ project }) => {
  const { user } = useContext(DataContext);
  const noExternalAccounts = project.owners.every(
    (owner) => !owner.externalAccountStatuses || owner.externalAccountStatuses.length === 0,
  );
  const hasErrorExternalAccounts = project.owners.some(
    (owner) => owner.externalAccountStatuses && owner.externalAccountStatuses.some((account) => account.status === 'error'),
  );
  if (noExternalAccounts) {
    return null;
  }
  const displayAccountStatus = (account) => {
    switch (account.status) {
      case 'connected':
        return (
          <div>
            <span style={{ color: 'green' }}>Connected</span>
            {account.tokenExpiresAt && (
              <span>{` (Expires ${moment.tz(account.tokenExpiresAt, user.timeZone).fromNow()})`}</span>
            )}
          </div>
        );
      case 'error':
        return <span style={{ color: 'red' }}>Error</span>;
      default:
        return <span>{account.status}</span>;
    }
  };
  return (
    <Segment>
      <Header as="h3">External calendar connection statuses</Header>
      {hasErrorExternalAccounts && (
        <Message negative>
          {'External calendar connections with errors could lead to scheduling issues.'}
          {' Please ask the respective owner(s) to reconnect their calendar(s) in the '}
          <Link to="/settings/availability/external_calendars" style={{ color: '#A03A3E', textDecoration: 'underline' }}>settings</Link>
          .
        </Message>
      )}
      <List divided relaxed>
        {project.owners.map((owner) => (
          <List.Item key={owner.id}>
            <List.Content>
              <List.Header>{owner.email}</List.Header>
              {(!owner.externalAccountStatuses || owner.externalAccountStatuses.length === 0) ? (
                <List.Description>(No external calendars linked.)</List.Description>
              ) : (
                <List.List>
                  {owner.externalAccountStatuses.map((account) => (
                    <List.Item key={account.id}>
                      <List.Content>
                        <List.Header>{`${account.provider} calendar`}</List.Header>
                        <List.Description>
                          {displayAccountStatus(account)}
                        </List.Description>
                      </List.Content>
                    </List.Item>
                  ))}
                </List.List>
              )}
            </List.Content>
          </List.Item>
        ))}
      </List>
    </Segment>
  );
};

export default ExternalAccountStatuses;
